import { render, staticRenderFns } from "./HowXt.vue?vue&type=template&id=42c77484&scoped=true"
import script from "./HowXt.vue?vue&type=script&lang=ts"
export * from "./HowXt.vue?vue&type=script&lang=ts"
import style0 from "./HowXt.vue?vue&type=style&index=0&id=42c77484&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c77484",
  null
  
)

export default component.exports